"use strict";

function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
define('controller/reporting/list',['require','exports','module','underscore','../../config','langs','../base','backbone','handlebars','../../view/page.list','../../view/table.ellipsis','../../view/empty.table','uikit/uikit','rs/modals/system.report.modal/system.report.modal.controller','../../model/report','../../libs/route.helper','../../libs/format/date','e3-modal','templates','uikit/uikit'],function (require, exports, module) {
  var _ = require('underscore');
  var config = require('../../config');
  var langs = require('langs');
  var RegionController = require('../base');
  var Backbone = require('backbone');
  var Handlebars = require('handlebars');
  var PageListView = require('../../view/page.list');
  var TableEllipsis = require('../../view/table.ellipsis');
  var EmptyTableView = require('../../view/empty.table');
  var ButtonView = require('uikit/uikit').Button;
  var SystemReportModalController = require('rs/modals/system.report.modal/system.report.modal.controller');
  var Report = require('../../model/report');
  var RouteHelper = require('../../libs/route.helper');
  var dateFormatter = require('../../libs/format/date');
  var E3Modal = require('e3-modal');
  var Templates = require('templates');
  var UIKit = require('uikit/uikit');
  var p = langs.phrase;
  function generateReportEditLink(model) {
    return RouteHelper.createLink('reporting:detail', model, {
      reportId: 'id'
    });
  }
  function navigateReportEdit(model) {
    app.navigate(generateReportEditLink(model).slice(1), {
      trigger: true
    });
  }
  function downloadReport(model, isSystemReport, obj) {
    var reports = obj.reports,
      state = obj.state;
    setTimeout(function () {
      $("#live-text").html("The report is in process to be downloaded Please review your downloads to find your report");
    }, 1000);
    model.runReportUrl(isSystemReport).promise().then(function () {
      var noRetries = 60;
      model.getReportStatusUrl(noRetries).then(function () {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", model.downloadReportUrl(isSystemReport) + "?_csrf=" + window._csrf_token + "&v=csvh");
        xhr.send();
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var data = xhr.response;
            var blobUrl = window.URL.createObjectURL(data);
            var a = document.createElement("a");
            a.style.display = "none";
            a.href = blobUrl;
            a.download = model.attributes.name ? model.attributes.name + ".csv" : "ReportResult.csv";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            $("#live-text").html("");
            a.remove();
            activateModal('Your report has finished running. You can find the report under your downloads.');
            setTimeout(function () {
              reports.fetch({
                data: {
                  q: state === 'custom' ? IRB_AUDIT_REPORT_TYPE_ID : IRB_SYSTEM_GENERATED_REPORT_TYPE_ID,
                  t: state === 'custom' ? false : true
                }
              });
            }, 2000);
          }
        };
        model.unset('formData');
        model.stopListening();
      })["finally"](app.request('dimmer'));
    });
  }
  function activateModal(text) {
    E3Modal.BtnMsgModal.show({
      title: 'Downloads',
      message: text,
      buttons: ['OK']
    });
  }
  function systemReportNameWithDescription(val, model) {
    var text = new Handlebars.SafeString("<span style=\"display: flex;\">".concat(val, " &nbsp\n          <div class=\"icon-container\" tabindex=\"0\" aria-label=\"").concat(model.attributes.description, "\">\n            <span class=\"fa-icon fa-icon-info-circle tooltip-icon\" ></span>\n            <div class=\"tooltip-message\">").concat(model.attributes.description, "</div>\n          </div>\n      </span>"));
    return text;
  }
  function authorNameFormatter() {
    return 'System Generated';
  }
  function createNewReportButton() {
    return new ButtonView({
      text: p('ReportingPage.CreateReportButton'),
      icon: 'plus',
      color: 'primary',
      link: "#report/create",
      attributes: {
        role: 'button',
        'aria-label': p('ReportingPage.CreateReportButton.ARIALabel')
      }
    });
  }
  var CUSTOM_REPORT_COLUMNS = [{
    text: 'Manage',
    useAccessibilityText: true,
    childView: TableEllipsis,
    sortable: false,
    collapsing: true,
    childViewOptions: setupRowActions
  }, {
    text: p('ReportingPage.Columns.Name'),
    data: 'name',
    sortable: false
  }, {
    text: p('ReportingPage.Columns.Author'),
    data: 'authorDisplayName',
    sortable: false
  }, {
    text: p('ReportingPage.Columns.CreateDate'),
    data: 'createDate',
    formatter: dateFormatter(config.dateFormat),
    sortable: false
  }, {
    text: p('ReportingPage.Columns.ModifyDate'),
    data: 'modifiedDate',
    formatter: dateFormatter(config.dateFormat),
    sortable: false
  }, {
    text: p('ReportingPage.Columns.LastRunDate'),
    data: 'lastRunDate',
    formatter: dateFormatter(config.dateFormat),
    sortable: false
  }];
  var SYSTEM_REPORT_COLUMNS = [{
    text: 'Manage',
    useAccessibilityText: true,
    childView: TableEllipsis,
    sortable: false,
    collapsing: true,
    childViewOptions: setupSystemReportsRowActions
  }, {
    text: p('ReportingPage.System.Report.Columns.Name'),
    data: 'name',
    formatter: systemReportNameWithDescription,
    sortable: false
  }, {
    text: p('ReportingPage.System.Report.Columns.Author'),
    data: 'authorDisplayName',
    formatter: authorNameFormatter,
    sortable: false
  }, {
    text: p('ReportingPage.System.Report.Columns.LastRunDate'),
    data: 'lastRunDate',
    formatter: dateFormatter(config.dateFormat),
    sortable: false
  }];
  var IRB_AUDIT_REPORT_TYPE_ID = 1;
  var IRB_SYSTEM_GENERATED_REPORT_TYPE_ID = 3;
  var SYSTEM_REPORT_STUDIES_BY_SPONSOR = "Studies By Sponsors";
  var SYSTEM_REPORT_SUBMISSION_TURNAROUND_TIME = "Submission Turnaround Time";
  var SYSTEM_REPORT_ANALYST_WORKLOAD = "Analyst Workload";
  var SYSTEM_REPORT_REVIEWER_WORKLOAD = "Reviewer Workload";
  function setupRowActions() {
    return {
      collection: new Backbone.Collection([{
        text: p('ReportingPage.RowAction.Run'),
        icon: 'play',
        action: 'run'
      }, {
        text: p('ReportingPage.RowAction.Edit'),
        icon: 'edit',
        action: 'edit',
        link: generateReportEditLink(this.model)
      }, {
        text: p('ReportingPage.RowAction.Delete'),
        icon: 'remove',
        action: 'destroy'
      }]),
      childBindings: {
        text: 'text',
        icon: 'icon',
        link: 'link'
      },
      ariaLabel: 'manage reports'
    };
  }
  function setupSystemReportsRowActions() {
    return {
      collection: new Backbone.Collection([{
        text: p('ReportingPage.RowAction.Run'),
        icon: 'play',
        action: 'run'
      }]),
      childBindings: {
        text: 'text',
        icon: 'icon',
        link: 'link'
      },
      ariaLabel: 'manage reports'
    };
  }
  var ToolbarMenuItem = UIKit.Menu.Item.extend({
    events: _.extend(UIKit.Menu.Item.prototype.events, {
      'keydown': 'handleToolbarOnKeydown'
    }),
    handleToolbarOnKeydown: function handleToolbarOnKeydown(ev) {
      switch (ev.keyCode) {
        case 13:
          ev.preventDefault();
          this.handleClick();
          break;
        case 37:
        case 39:
          var toolbarItems = this._parent._views;
          var nextToolbarItem = toolbarItems[0].view === this ? toolbarItems[1].view : toolbarItems[0].view;
          ev.preventDefault();
          nextToolbarItem.$el.focus();
          break;
        default:
          break;
      }
    }
  });
  var ReportingListController = RegionController.extend({
    header: p('App.Title'),
    features: ['reporting'],
    getStudyColumns: function getStudyColumns() {
      if (this.state.get('type') == 'system') {
        return SYSTEM_REPORT_COLUMNS;
      } else return CUSTOM_REPORT_COLUMNS;
    },
    onChangeStateType: function onChangeStateType() {
      if (this.state.get('type') == 'system') {
        this.root.systemMenuItem.active = true;
        this.root.customMenuItem.active = false;
        this.root.systemMenuItem.$el.attr('aria-selected', 'true');
        this.root.customMenuItem.$el.attr('aria-selected', 'false');
        this.root.systemMenuItem.$el.attr('aria-pressed', 'true');
        this.root.customMenuItem.$el.attr('aria-pressed', 'false');
        delete this.root.headerRightContainer;
      } else if (this.state.get('type') == 'custom') {
        this.root.customMenuItem.active = true;
        this.root.customMenuItem.$el.attr('aria-selected', 'true');
        this.root.systemMenuItem.$el.attr('aria-selected', 'false');
        this.root.customMenuItem.$el.attr('aria-pressed', 'true');
        this.root.systemMenuItem.$el.attr('aria-pressed', 'false');
        this.root.systemMenuItem.active = false;
        this.root.headerRightContainer.add(createNewReportButton());
      }
      this.root.setupColumns(this.getStudyColumns());
    },
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      self = this;
      app.execute('achievement:unlock', 'TPS Reports');
      var root = new PageListView({
          search: false,
          usePageHeader: false,
          useTableHeader: true,
          tableHeaderLevel: '4',
          tableHeaderText: state.get('type') === 'custom' ? p('ReportingPage.Custom.Report.Table.Header.Name') : p('ReportingPage.System.Report.Table.Header.Name'),
          hideTableHeaderFromScreens: false,
          tableHeaderId: state.get('type') === 'custom' ? 'customerGeneratedReports' : 'systemGeneratedReports'
        }),
        reports = Report.all(),
        table = root.table;
      this.root = root;
      this.reports = reports;
      systemReports = Report.all();
      root.$el.css(config.contentCss);
      function onRowActionCustom(row, child, actionModel) {
        var model = row.model;
        switch (actionModel.get('action')) {
          case 'run':
            downloadReport(row.model, false, {
              reports: reports,
              state: state.get('type')
            });
            break;
          case 'edit':
            navigateReportEdit(row.model);
            break;
          case 'destroy':
            app.request('modal', {
              type: 'CONFIRM_DESTROY',
              state: state,
              name: model.get('name'),
              entity: 'Report'
            }, {
              ariaControlsId: row.cid
            }).on('destroy:model', function () {
              model.destroy({
                wait: true,
                animate: 'scale'
              });
            });
            break;
        }
      }
      function onRowActionSystem(row, child, actionModel) {
        var model = row.model;
        switch (actionModel.get('action')) {
          case 'run':
            downloadSystemReport(model);
            break;
        }
      }
      function findSponsorModal(report) {
        SystemReportModalController.show({
          reportModel: report,
          props: {
            lookupLabelOne: 'Study Status',
            lookupLabelTwo: 'Study Sponsor',
            title: "Find Sponsor",
            systemReportInputOne: 'studyStatus',
            systemReportInputTwo: 'sponsor'
          }
        });
        report.listenTo(report, 'change:formData', function (model, response, options) {
          if (_.isObject(response)) {
            downloadReport(report, true, {
              reports: reports,
              state: state.get('type')
            });
          }
        });
      }
      function findSubmissionTypeModal(report) {
        SystemReportModalController.show({
          reportModel: report,
          props: {
            lookupLabelOne: 'Submission Type',
            lookupLabelTwo: 'Principal Investigator',
            title: "Find Submission Type",
            systemReportInputOne: 'submissionType',
            systemReportInputTwo: 'principalInvestigators'
          }
        });
        report.listenTo(report, 'change:formData', function (model, response, options) {
          if (_.isObject(response)) {
            downloadReport(report, true, {
              reports: reports,
              state: state.get('type')
            });
          }
        });
      }
      function findAnalystModal(report) {
        SystemReportModalController.show({
          reportModel: report,
          props: {
            lookupLabelOne: 'Completed Vs Outstanding Assignments',
            lookupLabelTwo: 'Analyst Name',
            lookupLabelOneType: 'single',
            lookupLabelTwoType: 'multiple',
            title: "Find Analysts",
            systemReportInputOne: 'assignments',
            systemReportInputTwo: 'analysts'
          }
        });
        report.listenTo(report, 'change:formData', function (model, response, options) {
          if (_.isObject(response)) {
            downloadReport(report, true, {
              reports: reports,
              state: state.get('type')
            });
          }
        });
      }
      function findReviewerModal(report) {
        SystemReportModalController.show({
          reportModel: report,
          props: {
            lookupLabelOne: 'Completed Vs Outstanding Assignments',
            lookupLabelTwo: 'Reviewer Name',
            lookupLabelOneType: 'single',
            lookupLabelTwoType: 'multiple',
            title: "Find Reviewer",
            systemReportInputOne: 'assignments',
            systemReportInputTwo: 'reviewers'
          }
        });
        report.listenTo(report, 'change:formData', function (model, response, options) {
          if (_.isObject(response)) {
            downloadReport(report, true, {
              reports: reports,
              state: state.get('type')
            });
          }
        });
      }
      function downloadSystemReport(report) {
        var _report$attributes;
        switch (report === null || report === void 0 || (_report$attributes = report.attributes) === null || _report$attributes === void 0 ? void 0 : _report$attributes.name) {
          case SYSTEM_REPORT_STUDIES_BY_SPONSOR:
            findSponsorModal(report);
            break;
          case SYSTEM_REPORT_SUBMISSION_TURNAROUND_TIME:
            findSubmissionTypeModal(report);
            break;
          case SYSTEM_REPORT_ANALYST_WORKLOAD:
            findAnalystModal(report);
            break;
          case SYSTEM_REPORT_REVIEWER_WORKLOAD:
            findReviewerModal(report);
            break;
          default:
            break;
        }
      }
      table.on('row:before:add:child', function (row, child) {
        if (child instanceof TableEllipsis) {
          child.on('action', _.partial(state.get('type') === 'custom' ? onRowActionCustom : onRowActionSystem, row));
        }
      });
      root.headerLeftContainer.add(new UIKit.Container({
        attributes: {
          style: 'margin-top: 1em;'
        }
      }).add(new UIKit.Menu({
        template: Templates.IRB['studylist.tabs.menu'],
        className: UIKit.Menu.prototype.className,
        secondary: true,
        pointing: true,
        compact: true,
        color: 'blue'
      }).add(this.root.customMenuItem = new ToolbarMenuItem({
        text: p('ReportingPage.Custom.Report.Toggle.Name'),
        link: true,
        role: "tab",
        attributes: _.extend(ToolbarMenuItem.prototype.attributes, {
          'aria-label': p('ReportingPage.Custom.Report.Toggle.ARIALabel')
        })
      }).on('press', function () {
        state.set('type', 'custom');
        root.tableHeaderText = p('ReportingPage.Custom.Report.Table.Header.Name');
      })).add(this.root.systemMenuItem = new ToolbarMenuItem({
        text: p('ReportingPage.System.Report.Toggle.Name'),
        link: true,
        role: "tab",
        attributes: _.extend(ToolbarMenuItem.prototype.attributes, {
          'aria-label': p('ReportingPage.System.Report.Toggle.ARIALabel')
        })
      }).on('press', function () {
        state.set('type', 'system');
        root.tableHeaderText = p('ReportingPage.System.Report.Table.Header.Name');
      }))));
      root.setupCollection(reports, {
        autoFetch: true
      }).setupState(state).setupEmptyView(EmptyTableView.Row, {
        text: p('ReportingPage.NoReports'),
        headerTag: 'h4'
      });
      table.selection = 'single';
      table.striped = false;
      table.selectable = true;
      table.sortable = false;
      root.listenToOnce(reports, 'sync', function () {
        if (reports.length > 0) {
          region.show(root);
        }
      }).listenTo(table, 'row:double:press', function (row) {
        if (state.get('type') === 'custom') {
          navigateReportEdit(row.model);
        }
      });
      state.addPageDependencies([reports]).on('page:loaded', function () {
        region.show(root);
      });
      this.listenTo(state, 'change:type', this.onChangeStateType);
      this.listenTo(state, 'change:type', _.debounce(function () {
        if (state.get('type') === 'custom') {
          reports.fetch({
            data: {
              q: IRB_AUDIT_REPORT_TYPE_ID,
              t: false
            }
          });
        } else {
          reports.fetch({
            data: {
              q: IRB_SYSTEM_GENERATED_REPORT_TYPE_ID,
              t: true
            }
          });
        }
      }));
      this.onChangeStateType();
      systemReports.fetch({
        data: {
          q: IRB_SYSTEM_GENERATED_REPORT_TYPE_ID,
          t: false
        },
        success: function success(reportModel, reportList) {
          function processItems(_x) {
            return _processItems.apply(this, arguments);
          }
          function _processItems() {
            _processItems = _asyncToGenerator(_regenerator().m(function _callee(callback) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return Promise.all(reportList.map(function (report, index) {
                      return new Promise(function (resolve) {
                        return setTimeout(function () {
                          switch (report.name) {
                            case SYSTEM_REPORT_STUDIES_BY_SPONSOR:
                            case SYSTEM_REPORT_SUBMISSION_TURNAROUND_TIME:
                            case SYSTEM_REPORT_ANALYST_WORKLOAD:
                            case SYSTEM_REPORT_REVIEWER_WORKLOAD:
                              createNewSystemReportCallback(report);
                          }
                          resolve();
                        }, index * 1000);
                      });
                    }));
                  case 1:
                    setTimeout(function () {
                      callback();
                    }, 1000);
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return _processItems.apply(this, arguments);
          }
          processItems(function () {
            reports.fetch({
              data: {
                q: state.get('type') === 'custom' ? IRB_AUDIT_REPORT_TYPE_ID : IRB_SYSTEM_GENERATED_REPORT_TYPE_ID,
                t: state.get('type') === 'custom' ? false : true
              }
            });
          });
          function createNewSystemReportCallback(attr) {
            reports.model.prototype.createNewSystemReport({
              "data": attr.data,
              "name": attr.name,
              "description": attr.description,
              "type": {
                "id": IRB_SYSTEM_GENERATED_REPORT_TYPE_ID
              }
            });
          }
        }
      });
      reports.fetch({
        data: {
          q: state.get('type') === 'custom' ? IRB_AUDIT_REPORT_TYPE_ID : IRB_SYSTEM_GENERATED_REPORT_TYPE_ID,
          t: state.get('type') === 'custom' ? false : true
        }
      });
    }
  });
  module.exports = ReportingListController;
});

